export const getTaxonomyListWithDefault = (
  taxonomyList: any[],
  allLabel: string
) => {
  return taxonomyList.map((level, index) => {
    // Ensure level is an array and flatten any nested arrays
    const flattenedLevel = Array.isArray(level)
      ? level.flat().filter((item) => item && typeof item === 'object' && !Array.isArray(item))
      : [];
    
    if (index === 0) {
      return [
        {
          label: allLabel || 'All',
          id: 'all',
          selected: false,
        },
        ...flattenedLevel,
      ];
    }
    return [...flattenedLevel];
  });
};
